// extracted by mini-css-extract-plugin
export default {"toc":"TableOfContents_toc__uldmb"};